module.exports = __webpack_public_path__ + "static/media/hangman_game_ilus.dfa1acbb.jpg";